var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"display-inline"},[_vm._v("Jobs Audit Report")]),_c('div',{staticClass:"display-inline ml-3"},[_c('ActiveApiCalls')],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('JobsAuditReport')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }